import React, { useEffect, useState } from "react";
import { database, auth } from "../modules/fireBase";
import {
  Typography,
  Table,
  Button,
  Upload,
  message,
  Dropdown,
  Menu,
  Modal,
  BackTop,
} from "antd";
import "../assets/styles/PlanificationMultiple.css";
import CustomLayout from "./CustomLayout";
import { FaCalendarPlus } from "react-icons/fa";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CloseOutlined } from "@ant-design/icons";
import { FaCloudUploadAlt, FaPrint } from "react-icons/fa";
import { generatePdfPlanifMultiple } from "../modules/pdfGenerator";
dayjs.extend(customParseFormat);
dayjs.locale("fr");

const { Title, Text } = Typography;

export default function PlanificationMultiple() {
  const [contactChantier, setContactChantier] = useState(undefined);
  const [contactBureau, setContactBureau] = useState(undefined);
  const [planifColumns, setPlanifColumns] = useState([]);
  const [planifTitles, setPlanifTitles] = useState([]);
  const [planifData, setPlanifData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    database.ref("chantierContacts").once("value", (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setContactChantier(firebaseData);
        setPlanifData(firebaseData);
      }
    });
    database.ref("bureauContacts").once("value", (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setContactBureau(firebaseData);
      }
    });
  }, []);
  const loadFile = async (e) => {
    if (e.fileList.length > 0) {
      //setLoading(true);
      message.loading({
        content: "Veuillez patienter...",
        key: "upload",
        duration: 10,
      });
      let file = await toBase64(e.file);
      //setFileName(e.file.name);
      let adresseplanif =
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
          ? "http://localhost:5001/artext-92d42/us-east1/planif"
          : "https://us-east1-artext-92d42.cloudfunctions.net/planif";
      axios
        .post(adresseplanif, {
          file: file,
          contactChantier: contactChantier,
          contactBureau: contactBureau,
        })
        .then((result) => {
          message.success({
            content: "La planifcation a bien été ajoutée!",
            key: "upload",
            duration: 3,
          });
          newPlanifDowloaded({ ...result.data, fileName: e.file.name });
          //setLoading(false);
        });
    }
  };
  const newPlanifDowloaded = (newPlanif) => {
    let randomid = uuidv4();
    let newPlanifData = [];
    planifData.forEach((employe) => {
      let projects = newPlanif.projectsperEmploye.find(
        (e) => e.key === employe.key
      ).projects;
      newPlanifData.push({ ...employe, [randomid]: [...projects] });
    });
    setPlanifData(newPlanifData);
    let newColumns = [...planifColumns];
    let newPlanifTitles = [...planifTitles];
    let planifDate = `${capitalize(
      dayjs(newPlanif.planifdate, "D MMMM YYYY").format("dddd")
    )} ${dayjs(newPlanif.planifdate, "D MMMM YYYY").format("DD")} ${capitalize(
      dayjs(newPlanif.planifdate, "D MMMM YYYY").format("MMMM")
    )} ${dayjs(newPlanif.planifdate, "D MMMM YYYY").format("YYYY")}`;
    newPlanifTitles.push({ date: planifDate, id: randomid });
    setPlanifTitles(newPlanifTitles);
    newColumns.push({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div>{planifDate}</div>
            <div
              style={{
                fontWeight: 400,
                textDecoration: "underline",
              }}
            >
              {newPlanif.fileName}
            </div>
          </div>
          {/* <div>
            <Button
              type="primary"
              danger
              icon={<CloseOutlined />}
              size="small"
              onClick={() => {
                deleteColumn(randomid);
              }}
            />
          </div> */}
        </div>
      ),
      dataIndex: randomid,
      key: randomid,
      render: (p) => (
        <>
          {p?.map((project, index) => {
            let color = getColor(project);
            if (project === "OFF") {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    margin: 10,
                    backgroundColor: color.background,
                    border: `1px solid ${color.border}`,
                    borderRadius: 3,
                    color: color.color,
                  }}
                >
                  <div>
                    <span style={{ fontWeight: "bold" }}>OFF</span>
                  </div>
                </div>
              );
            }
            if (project === "CONGÉ") {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    margin: 10,
                    backgroundColor: color.background,
                    border: `1px solid ${color.border}`,
                    borderRadius: 3,
                    color: color.color,
                  }}
                >
                  <div>
                    <span style={{ fontWeight: "bold" }}>CONGÉ</span>
                  </div>
                </div>
              );
            }
            return (
              <div
                key={index}
                style={{
                  //marginTop: index > 0 ? '5px' : '0px',
                  padding: 10,
                  margin: 10,
                  backgroundColor: color.background,
                  border: `1px solid ${color.border}`,
                  borderRadius: 3,
                  color: color.color,
                }}
              >
                <div>
                  <span style={{ fontWeight: "bold" }}>Départ : </span>
                  <span>
                    {dayjs(project.depart, "HH:mm").format("HH:mm A")}
                  </span>
                </div>
                {project.remarques.trim().length > 2 && (
                  <div>
                    <span style={{ fontWeight: "bold" }}>Remarques : </span>
                    <span>{project.remarques}</span>
                  </div>
                )}
              </div>
            );
          })}
        </>
      ),
    });
    setPlanifColumns(newColumns);
  };
  const deleteColumn = (id) => {
    let newPlanifData = [...planifData];
    newPlanifData = newPlanifData.map((employe) => {
      delete employe[id];
      return employe;
    });
    setPlanifData(newPlanifData);
    let newColumns = [...planifColumns];
    newColumns = newColumns.filter((column) => column.dataIndex !== id);
    setPlanifColumns(newColumns);
    let newPlanifTitles = [...planifTitles];
    newPlanifTitles = newPlanifTitles.filter((planif) => planif.id !== id);
    setPlanifTitles(newPlanifTitles);
  };
  const getColumns = () => {
    return (
      <Menu>
        {planifTitles.map((planif) => (
          <Menu.Item
            key={planif.id}
            onClick={() => {
              Modal.confirm({
                title: "Êtes-vous sûr de vouloir supprimer la planification ?",
                content: (
                  <div>
                    <p>{planif.date}</p>
                  </div>
                ),
                okText: "Supprimer",
                cancelText: "Annuler",
                onOk: () => {
                  deleteColumn(planif.id);
                },
              });
            }}
          >
            {planif.date}
          </Menu.Item>
        ))}
      </Menu>
    );
  };
  return (
    <CustomLayout
      selectedKey="3"
      contentStyle={{
        display: "flex",
        flexDirection: "column",
        height: 0,
      }}
    >
      <Title>Planification Multiple</Title>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ textAlign: "left", marginBottom: 10, display: "flex" }}>
          <Upload
            fileList={[]}
            name="uploadplanif"
            beforeUpload={(file) => {
              return false;
            }}
            onDownload={() => console.log("onDownload")}
            onChange={(e) => {
              loadFile(e);
            }}
            listType="picture"
            accept=".pdf"
          >
            <Button type="primary" onClick={() => {}}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCalendarPlus style={{ marginRight: 5 }} />
                Ajouter une planification
              </div>
            </Button>
          </Upload>
          <Dropdown
            overlay={getColumns()}
            trigger={["click"]}
            disabled={!planifColumns.length > 0}
          >
            <Button
              //type="primary"
              onClick={(e) => e.preventDefault()}
              //danger
              style={{ marginLeft: 10 }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CloseOutlined style={{ marginRight: 5 }} />
                Supprimer une planification
              </div>
            </Button>
          </Dropdown>
        </div>
        <Button
          type="primary"
          style={{ marginLeft: 10 }}
          danger
          onClick={() => {
            generatePdfPlanifMultiple(planifTitles, planifData);
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaPrint style={{ marginRight: 5 }} />
            Imprimer la planification
          </div>
        </Button>
      </div>
      <div
        style={{
          flex: 1,
          overflow: "auto",
        }}
        id="planifmultiple-table-div"
      >
        <Table
          dataSource={planifData}
          //columns={columns}
          pagination={false}
          bordered
          sticky
        >
          <Table.Column
            key="nom"
            title="Nom"
            dataIndex="nom"
            defaultSortOrder="ascend"
            sorter={(a, b) => a.nom.localeCompare(b.nom)}
          />
          <Table.Column
            key="prenom"
            title="Prénom"
            dataIndex="prenom"
            defaultSortOrder="ascend"
            sorter={(a, b) => a.prenom.localeCompare(b.prenom)}
          />
          {planifColumns.map((column) => (
            <Table.Column
              key={column.key}
              title={column.title}
              dataIndex={column.dataIndex}
              render={column.render}
            />
          ))}
        </Table>
        <BackTop
          target={() => document.getElementById("planifmultiple-table-div")}
        />
        {/* </div> */}
      </div>
    </CustomLayout>
  );
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

function getColor(project) {
  if (project.remarques === "OUT") {
    return { background: "#fff7e6", border: "#ffd591", color: "#d46b08" };
  }
  switch (project.depart) {
    case "17:30":
    case "18:00":
    case "18:30":
    case "19:00":
    case "19:30":
    case "20:00":
    case "20:30":
    case "21:00":
    case "21:30":
    case "22:00":
    case "22:30":
    case "23:00":
    case "23:30":
    case "00:00":
    case "00:30":
    case "01:00":
    case "01:30":
    case "02:00":
    case "02:30":
    case "03:00":
    case "03:30":
    case "04:00":
    case "04:30":
      return { background: "#f6ffed", border: "#b7eb8f", color: "#389e0d" };
    case "05:00":
    case "05:30":
    case "06:00":
    case "06:30":
    case "07:00":
    case "07:30":
    case "08:00":
    case "08:30":
    case "09:00":
    case "09:30":
    case "10:00":
    case "10:30":
    case "11:00":
    case "11:30":
    case "12:00":
    case "12:30":
    case "13:00":
    case "13:30":
    case "14:00":
    case "14:30":
    case "15:00":
    case "15:30":
    case "16:00":
    case "16:30":
    case "17:00":
      return { background: "#ffffc7", border: "#eded00", color: "#8c7e00" };
  }
  switch (project) {
    case "CONGÉ":
      return { background: "#e6f7ff", border: "#91d5ff", color: "#096dd9" };
    case "OFF":
      return { background: "#fff0f6", border: "#ffadd2", color: "#c41d7f" };
  }
}
